/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ChallengeUpdateArgs,
  DeleteChallengeRequest,
  HTTPValidationError,
  OrganizationBusinessChallengesResponse,
} from './platformapi.schemas';

import getOrganizationBusinessChallengesMutator from '../custom-axios-instance';
import updateOrganizationBusinessChallengeMutator from '../custom-axios-instance';
import clearChallengeDataMutator from '../custom-axios-instance';

/**
 * Retrieves the business challenges for a given organization
 * @summary Get Organization Business Challenges
 */
export const getOrganizationBusinessChallenges = (organizationId: number, signal?: AbortSignal) => {
  return getOrganizationBusinessChallengesMutator<OrganizationBusinessChallengesResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/business-challenges/${organizationId}`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationBusinessChallengesQueryKey = (organizationId: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/business-challenges/${organizationId}`] as const;
};

export const getGetOrganizationBusinessChallengesQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationBusinessChallengesQueryKey(organizationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>> = ({
    signal,
  }) => getOrganizationBusinessChallenges(organizationId, signal);

  return { queryKey, queryFn, enabled: !!organizationId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationBusinessChallengesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>
>;
export type GetOrganizationBusinessChallengesQueryError = void | HTTPValidationError;

export function useGetOrganizationBusinessChallenges<
  TData = Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBusinessChallenges<
  TData = Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationBusinessChallenges<
  TData = Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Organization Business Challenges
 */

export function useGetOrganizationBusinessChallenges<
  TData = Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationBusinessChallenges>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationBusinessChallengesQueryOptions(organizationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates a business challenge for a given organization.
 * @summary Update Organization Business Challenge
 */
export const updateOrganizationBusinessChallenge = (
  organizationId: number,
  challengeUpdateArgs: ChallengeUpdateArgs,
  signal?: AbortSignal,
) => {
  return updateOrganizationBusinessChallengeMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/business-challenges/${organizationId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: challengeUpdateArgs,
    signal,
  });
};

export const getUpdateOrganizationBusinessChallengeMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganizationBusinessChallenge>>,
    TError,
    { organizationId: number; data: ChallengeUpdateArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganizationBusinessChallenge>>,
  TError,
  { organizationId: number; data: ChallengeUpdateArgs },
  TContext
> => {
  const mutationKey = ['updateOrganizationBusinessChallenge'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganizationBusinessChallenge>>,
    { organizationId: number; data: ChallengeUpdateArgs }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return updateOrganizationBusinessChallenge(organizationId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationBusinessChallengeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganizationBusinessChallenge>>
>;
export type UpdateOrganizationBusinessChallengeMutationBody = ChallengeUpdateArgs;
export type UpdateOrganizationBusinessChallengeMutationError = void | HTTPValidationError;

/**
 * @summary Update Organization Business Challenge
 */
export const useUpdateOrganizationBusinessChallenge = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrganizationBusinessChallenge>>,
      TError,
      { organizationId: number; data: ChallengeUpdateArgs },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganizationBusinessChallenge>>,
  TError,
  { organizationId: number; data: ChallengeUpdateArgs },
  TContext
> => {
  const mutationOptions = getUpdateOrganizationBusinessChallengeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Clears the business challenge for a given organization by setting the challenge and context to null
 * @summary Clear Challenge Data
 */
export const clearChallengeData = (
  organizationId: number,
  deleteChallengeRequest: DeleteChallengeRequest,
  signal?: AbortSignal,
) => {
  return clearChallengeDataMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/business-challenges/${organizationId}/delete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: deleteChallengeRequest,
    signal,
  });
};

export const getClearChallengeDataMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearChallengeData>>,
    TError,
    { organizationId: number; data: DeleteChallengeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clearChallengeData>>,
  TError,
  { organizationId: number; data: DeleteChallengeRequest },
  TContext
> => {
  const mutationKey = ['clearChallengeData'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clearChallengeData>>,
    { organizationId: number; data: DeleteChallengeRequest }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return clearChallengeData(organizationId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClearChallengeDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof clearChallengeData>>
>;
export type ClearChallengeDataMutationBody = DeleteChallengeRequest;
export type ClearChallengeDataMutationError = void | HTTPValidationError;

/**
 * @summary Clear Challenge Data
 */
export const useClearChallengeData = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof clearChallengeData>>,
      TError,
      { organizationId: number; data: DeleteChallengeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof clearChallengeData>>,
  TError,
  { organizationId: number; data: DeleteChallengeRequest },
  TContext
> => {
  const mutationOptions = getClearChallengeDataMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
